import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import { toast } from '@CommonComponents/toast'
import { useStateValue } from '@State'
import { client } from '@Utils'
import { canvasOrgKeyManagement as endpoints } from '@URLS'

const ResetOrgModal = ({orgId, show, toggle}) => {
  const [currentState, dispatch] = useStateValue()


  const resetNameAndDomain = async () => {
    try {
      await client.get(endpoints.resetOrg({ orgId: orgId }))
      toast.success("Successfully reset the name and URL for this organization.")
      dispatch({ type: 'reload', reload: !currentState.reloadSwitch })
      toggle(false)
    } catch (err) {
      console.log(err)
      toast.error("There was an error resetting this organization.")
    }
  }

  return (
    <Modal show={show} onHide={() => toggle(!show)}>
      <Modal.Header closeButton>
        <Modal.Title>Reset Org Name and Domain</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure that you want to reset the name and domain that are currently associated with this organization?
      </Modal.Body>
      <Modal.Footer>
        <div
          className="btn btn-success btn-myed btn-success-myed"
          onClick={() => resetNameAndDomain()}
        >
          <div className="fa-regular fa-undo fa-fw mr-2" /> Reset
        </div>
      </Modal.Footer>
    </Modal>
  )
}

ResetOrgModal.propTypes = {
  orgId: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}

export default ResetOrgModal
